'use strict'

module.exports = {
    fixViewportTag(siteData){
        const viewport = (typeof document !== "undefined") && window.document.getElementById("wixMobileViewport")
        if (viewport) {
            viewport.setAttribute('content', `width=${  siteData.getSiteWidth()  }, user-scalable=yes`)
        }
    }
}



// WEBPACK FOOTER //
// ./src/coreUtils/src/main/core/mobileViewportFixer.js